module.exports = __webpack_public_path__ + "img/resbg.9c2c6136.png";